import { Injectable } from '@angular/core';
import {
  HttpInterceptor, HttpRequest, HttpHandler,
  HttpEvent, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable()
export class ApiResponseInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const textReq = req.clone({ responseType: 'text' });

    return next.handle(textReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          return event.clone({ body: this.parse(event.body) });
        }
        return event;
      }),
      catchError((err: HttpErrorResponse) => {
        const parsedError = new HttpErrorResponse({
          error: this.parse(err.error),
          headers: err.headers,
          status: err.status,
          statusText: err.statusText,
          url: err.url || undefined
        });
        return throwError(parsedError);
      })
    ) as Observable<HttpEvent<any>>;
  }

  private parse(body: any): any {
    if (typeof body !== 'string') { return body; }
    try {
      return JSON.parse(body);
    } catch {
      return body;
    }
  }
}